import { BsSortAlphaDown, BsSortAlphaDownAlt } from "react-icons/bs";
import "../commonStyle.css";
import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_QUERIES_LIST_DATA } from "../../store/actionTypes";
import CustomPagination from "../customPagination";
import { FiFilter } from "react-icons/fi";
import ProperSpinner from "../spinner/ProperSpinner";
import { getDateAndTimeFormatted } from "../../utils/commonFunctions";
import { useNavigate } from "react-router-dom";
import { FeedbackStatus } from "../../utils/contentTypes";
import CustomModal from "../customModal";

/**
 * @function QueriesTable
 * @description for QueriesTable
 * @returns JSX for QueriesTable
 */

const QueriesTable = () => {
  const navigate = useNavigate();
  const {
    queriesList,
    pageNo,
    totalPage,
    limit,
    isLoading,
    sortOrder,
    status,
  } = useSelector((state) => state.QueriesReducer);

  const dispatch = useDispatch();
  const [filterModal, setFilterModal] = useState(false);
  const [localStatus, setLocalStatus] = useState(status);

  const handlerSort = () => {
    dispatch({
      type: UPDATE_QUERIES_LIST_DATA,
      payload: { sortOrder: sortOrder === 1 ? -1 : 1 },
    });
  };

  const updatePage = (page) => {
    dispatch({
      type: UPDATE_QUERIES_LIST_DATA,
      payload: { pageNo: page },
    });
  };

  const pageLimitHandler = (e) => {
    const currLimit = e?.target?.value;
    dispatch({
      type: UPDATE_QUERIES_LIST_DATA,
      payload: { limit: currLimit, pageNo: 1 },
    });
  };

  const handleFilter = (newStatus) => {
    setFilterModal(false);
    dispatch({
      type: UPDATE_QUERIES_LIST_DATA,
      payload: { pageNo: 1, status: newStatus },
    });
  };

  const renderTableBody = () => {
    return (
      <CTableBody>
        {queriesList?.length > 0 &&
          queriesList?.map((query, i) => {
            const serialNo = (pageNo - 1) * limit + (i + 1);
            return (
              <CTableRow key={i} className="table-data-text">
                <CTableDataCell className="table-heading-10-cell">
                  {serialNo}
                </CTableDataCell>
                <CTableDataCell
                  className="name-link cursor-pointer table-heading-20-cell"
                  onClick={() =>
                    navigate(`/queries/${query._id}`, {
                      state: { queryData: query },
                    })
                  }
                >
                  {query?.name || "N/A"}
                </CTableDataCell>
                <CTableDataCell className="table-heading-20-cell">
                  {query?.email || "N/A"}
                </CTableDataCell>
                <CTableDataCell className="table-heading-10-cell">
                  {query?.status === 4 ? (
                    <span className="badge rounded-pill bg-success">
                      Completed
                    </span>
                  ) : (
                    <span className="badge rounded-pill bg-danger">
                      Pending
                    </span>
                  )}
                </CTableDataCell>
                <CTableDataCell
                  className="text-truncate table-heading-30-cell"
                  style={{ maxWidth: "300px" }}
                >
                  {query?.description || "N/A"}
                </CTableDataCell>
                <CTableDataCell className="text-nowrap table-heading-20-cell">
                  {getDateAndTimeFormatted(query?.createdAt)}
                </CTableDataCell>
              </CTableRow>
            );
          })}
      </CTableBody>
    );
  };

  const renderPagination = () => {
    return (
      <CustomPagination
        limit={limit}
        limitHanlder={pageLimitHandler}
        pageNo={pageNo}
        pageChangeHanlder={updatePage}
        totalPage={totalPage}
      />
    );
  };

  const renderNoDataFound = () => {
    if (isLoading) {
      return (
        <div className="ndf-container">
          <h3 className="ndf-heading">
            <span>{" Fetching queries "}</span> {"..."}
          </h3>
        </div>
      );
    }
    return (
      <div className="ndf-container">
        <h3 className="ndf-heading">
          {"No"}
          <span>{" Queries "}</span> {"available !!!"}
        </h3>
      </div>
    );
  };

  const renderModalBody = () => {
    return (
      <div className="filter-modal-body-container">
        <div className="info-sub-child-container">
          <label className="lable-text" htmlFor="diveType">
            {"Query Status"}
          </label>
          <select
            name="diveType"
            id="diveType"
            value={localStatus}
            onChange={(e) => {
              setLocalStatus(e.target.value);
            }}
            className="form-select form-select-md"
            aria-label="Select Dive Type"
          >
            <option value="">{"Show All"}</option>
            {Object.entries(FeedbackStatus).map(([key, value], index) => (
              <option key={index} value={value}>
                {key}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };

  const renderView = () => {
    return (
      <div>
        <CustomModal
          visible={filterModal}
          visibleHandler={() => {
            setFilterModal(false);
            setLocalStatus(status);
          }}
          heading={"Query Status"}
          body={renderModalBody}
          confirmHandler={() => handleFilter(localStatus)}
        />
        <div className="table-header-container">
          <h3 className="mb-0 text-primary">{"Queries List"}</h3>
          <div
            className={`btn ${status ? "btn-primary" : "btn-outline-primary "} btn-sm add-btn add-btn-container `}
            onClick={() => setFilterModal(true)}
          >
            <span className="px-2">{"Filter"}</span>
            <span className="add-icon ">
              <FiFilter />
            </span>
          </div>
        </div>
        <CTable hover responsive>
          <CTableHead className="text-nowrap border">
            <CTableRow>
              <CTableHeaderCell className="bg-body-tertiary table-heading-10-cell">
                {"S. No."}
              </CTableHeaderCell>
              <CTableHeaderCell className="bg-body-tertiary table-heading-20-cell">
                {"Name"}
              </CTableHeaderCell>
              <CTableHeaderCell className="bg-body-tertiary table-heading-20-cell ">
                {"Email"}
              </CTableHeaderCell>
              <CTableHeaderCell className="bg-body-tertiary table-heading-10-cell">
                {"Status"}
              </CTableHeaderCell>
              <CTableHeaderCell className="bg-body-tertiary table-heading-30-cell ">
                {"Queries"}
              </CTableHeaderCell>
              <CTableHeaderCell className="bg-body-tertiary table-heading-20-cell ">
                {"Date"}
                <span onClick={handlerSort} className="cursor-pointer">
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          {isLoading ? <ProperSpinner /> : renderTableBody()}
        </CTable>
        {(queriesList?.length >= 5 || pageNo > 1) && renderPagination()}
        {(isLoading || queriesList?.length == 0) && renderNoDataFound()}
      </div>
    );
  };

  return <div>{renderView()}</div>;
};

export default QueriesTable;
